import { useState } from "react";
import { Layout, SectionTitle } from "@/components/Layout";
import { TutorialCard } from "@/components/cards";
import { getFavorites, getRecents } from "@/lib/local";
import { Star } from "lucide-react";
import { Link } from "react-router-dom";

export default function FavoritesPage() {
  const [favs] = useState(getFavorites());
  const [recents] = useState(getRecents());
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4 sm:px-8 py-14">
        <SectionTitle label="Meus tutoriais" title="Favoritos & Recentes"
          subtitle="Volte rapidamente aos tutoriais que você salvou ou visitou." />

        <div className="flex items-center gap-2 mb-4"><Star className="w-5 h-5 text-amber-300" /><h3 className="font-semibold">Meus Tutoriais Favoritos</h3></div>
        {favs.length > 0 ? (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 mb-12">{favs.map((t) => <TutorialCard key={t.slug} tut={t} />)}</div>
        ) : (
          <div className="ci-card p-8 text-center text-gray-400 mb-12">
            Você ainda não favoritou nenhum tutorial. Abra um tutorial e toque na estrela ⭐. <br />
            <Link to="/dispositivos" className="text-cyan-300 hover:underline">Ver dispositivos</Link>
          </div>
        )}

        {recents.length > 0 && (
          <>
            <h3 className="font-semibold mb-4">Vistos recentemente</h3>
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{recents.map((t) => <TutorialCard key={t.slug} tut={t} />)}</div>
          </>
        )}
      </div>
    </Layout>
  );
}
